import React from 'react';
import Link from 'gatsby-link';
import Template from '../../../../components/templates/Anatomy';

export default (props) => {
  return (
    <Template>
      <h1>
        components
      </h1>
      <p>
        This section describes the application structure.
      </p>
    </Template>
  );
};



// WEBPACK FOOTER //
// ./src/pages/anatomy/src/components/index.js